module.exports = __webpack_public_path__ + "static/media/5.9378d8bc.jpg";